<template>
  <div>
    <div class="row">
      <div class="col">
        <b-card class="box-shadow">
          <div class="row mb-2" >
            <div class="col-8">
               <h3 v-if="selectedAccount &&accounts.length==1">{{ selectedAccount.name }}</h3>
                <v-select
                  v-if="accounts.length>1"
                  label="name"
                  :options="accounts"
                  v-show="!loading"
                  v-model="selectedAccount"
                >
                  <template slot="option" slot-scope="p">
                    <div>
                      {{ p.name }} - {{ p.contact_number }}<br />
                      {{ p.email_address }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="p">
                    {{ p.name }}                     
                  </template>
                </v-select>
            </div>
            <div class="col-4 text-right" v-if="selectedAccount">
                <button class="btn btn-info text-white font-weight-bold">{{ selectedAccount.account.current_balance }}</button>
            </div>
          </div>
         
          
          <b-tabs v-if="selectedAccount">
            <b-tab title="Invoices"> 
              <invoices  :accountId="selectedAccount.account.id" :key="accountChanged"/>
            </b-tab>
            <b-tab title="Payments">
              <payments  :accountId="selectedAccount.account.id"  :key="accountChanged"/>
            </b-tab>
            <b-tab title="Credits">
              <credits  :accountId="selectedAccount.account.id"  :key="accountChanged"/>
            </b-tab>
            <b-tab title="Debits">
              <debits  :accountId="selectedAccount.account.id"  :key="accountChanged"/>
            </b-tab>
            <b-tab title="Statement">
              <statement  :accountId="selectedAccount.account.id"  :key="accountChanged"/>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import partnerAccountRepo from "@/api/repos/partnerAccountRepo";
import invoices from "@/views/modules/partner-account/invoices"
import payments from "@/views/modules/partner-account/payments"
import debits from "@/views/modules/partner-account/debits"
import credits from "@/views/modules/partner-account/credits"
import statement from "@/views/modules/partner-account/statement"

export default {
  components:{
    invoices,
    payments,
    debits,
    credits,
    statement
  },
  data() {
    return {
      accountChanged:1,
      accounts:[],
      selectedAccount:null,
      loading:false
    };
  },

  mounted() {
    this.getAccounts();
  },

  methods: {
   
    async getAccounts() {
      this.loading = true
      try {
        let { data } = await partnerAccountRepo.accounts();
        this.accounts = data.accounts
        this.selectedAccount = this.accounts[0]
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    selectedAccount: {
      immediate: true,
      handler: function () {
        this.accountChanged=this.accountChanged+1
      },
    },
  },
};
</script>

<style>
</style>